/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import {service as ConservationActionPhaseService} from "../../../Services/ConservationActionPhaseService";
import autobind from "autobind-decorator";
import Autocomplete from "react-autocomplete";
import {StreamBankAutoCompleteItem} from "../../../Components/Common/StreamBankAutoCompleteItem";
import React from "react";

export class ConservationActionPhaseFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.setInitialState({
			conservationActionPhases: [],
			value: "",
			values: []
		});
	}

	componentDidMount() {
		ConservationActionPhaseService.Get()
			.then((x) => {
				let value = "";

				if (this.props.Value) {
					let conservationActionPhase = x.result.find((x) => Number(x.conservationActionPhaseId) === Number(this.props.Value));

					if (conservationActionPhase) {
						value = conservationActionPhase.name;
					}
				}

				this.setState({
					conservationActionPhases: x.result,
					value: value
				}, () => {
					let values = this.state.conservationActionPhases.filter((x) => {
						return x.name.toLowerCase().includes(this.state.value.toLowerCase());
					}).slice(0, 20);

					this.setState({values: values});
				});
			});
	}

	@autobind
	_render() {
		return <div className="autocomplete-column">
			<Autocomplete
				value={this.state.value}
				inputProps={{className: 'autocomplete-input', placeholder: "Conservation Action Phase"}}
				wrapperStyle={{position: 'relative', display: 'inline-block'}}
				items={this.state.values}
				getItemValue={(item) => item.name}
				onChange={(event, value) => {
					this.setState({value: value}, () => {
						let values = this.state.conservationActionPhases.filter((x) => {
							return x.name.toLowerCase().includes(value.toLowerCase());
						}).slice(0, 20);

						this.setState({values: values});
					});
				}}
				onSelect={(value, item) => {
					this.setState({value: item.name}, () => {
						this.props.OnUpdate(item.conservationActionPhaseId)
					});
				}}
				renderMenu={children => (
					<div className="sb-autocomplete-menu sb-autocomplete-menu-conservationActionPhase">
						{children}
					</div>
				)}
				renderItem={(item, isHighlighted) => (
					<StreamBankAutoCompleteItem
						className="sb-autocomplete-item-conservationActionPhase"
						key={item.conservationActionPhaseId}
						isHighlighted={isHighlighted}
						title={item.name}
					/>
				)}
			/>
		</div>;
	}
}